"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSSCRefundOutputWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../commonFunctions");
var React = require("react");
var services_1 = require("@falcon/services");
var FalconSSCRefundOutputWidget = /** @class */ (function (_super) {
    __extends(FalconSSCRefundOutputWidget, _super);
    function FalconSSCRefundOutputWidget(props) {
        return _super.call(this, props) || this;
    }
    FalconSSCRefundOutputWidget.prototype.render = function () {
        var amount = this.props.interaction.factors.returnPremium;
        return (React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "content" },
                amount !== 0 && React.createElement("div", { id: "price", className: "text-center price-text-black-25" }, (0, commonFunctions_1.getAmountToDisplay)(amount)),
                React.createElement("div", { className: "price-text text-blue-2 pt-2" }, amount !== 0 ? "you will get refund to cancel your Flow ".concat(this.pickWordingForCancelledProduct(), "subscription") : "There is no refund due canceling your Flow ".concat(this.pickWordingForCancelledProduct(), "subscription")))));
    };
    FalconSSCRefundOutputWidget.prototype.pickWordingForCancelledProduct = function () {
        var interaction = this.props.interaction;
        if (interaction.uistate.productsForCancellation.length === 2) {
            return "Car and Renters ";
        }
        else if (interaction.uistate.productsForCancellation.length === 1) {
            if (interaction.uistate.productsForCancellation[0] === services_1.PRODUCT_MOTOR) {
                return "Car ";
            }
            else if (interaction.uistate.productsForCancellation[0] === services_1.PRODUCT_RENTERS) {
                return "Renters ";
            }
        }
        return "";
    };
    return FalconSSCRefundOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.FalconSSCRefundOutputWidget = FalconSSCRefundOutputWidget;
//# sourceMappingURL=FalconSSCRefundOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/FalconSSCRefundOutputWidget.js
// module id = 3266
// module chunks = 0